/**
 * Created by asiulik on 24.11.2017.
 */

define(['jquery', 'lodash', 'eventEmitter/EventEmitter', 'slick'], function ($, _, EventEmitter) {

    var CAMPAIGN_SLIDE_ACTIVE_CLASS = 'slick-active';

    function Campaign() {
    }

    Campaign.prototype = _.clone(EventEmitter.prototype);

    Campaign.prototype.init = function () {


        var _this = this;
        var $sliderElement = $('.t__campaign__slider__content');
        var $slides = $sliderElement.find('.image__text__slider__item-wrapper');

        $sliderElement.slick({
            arrows: false,
            dots: true,
            speed: 1000,
            autoplay: true,
            pauseOnHover: false,
            autoplaySpeed: $sliderElement.data('sliderInterval') || 2000
        });

        $sliderElement.on('beforeChange', function (event, slick, currentSlide, nextSlide) {

            var $currentSlide = $slides.eq(currentSlide);
            $currentSlide.addClass(CAMPAIGN_SLIDE_ACTIVE_CLASS);

        });

        $sliderElement.on('afterChange', function (event, slick, currentSlide, nextSlide) {

            $slides.removeClass(CAMPAIGN_SLIDE_ACTIVE_CLASS);
            $slides.eq(currentSlide).addClass(CAMPAIGN_SLIDE_ACTIVE_CLASS)


        });

        var $clonedSlides = $sliderElement.find('.slick-cloned');
        setTimeout(function () {
            _this.emit('home:preloadClonedImages', $clonedSlides)
        }, 2000)


    };

    return Campaign;

});



// WEBPACK FOOTER //
// ./Private/Scripts/pages/campaign.js